const aboutDetails = [
  {
    title: `Time tracking is Communication`,
    details: `Individuals communicate work done to clients orleaders. `,
  },
  {
    title: `No one likes being constantly monitored`,
    details: `The best companies lead with purpose, not fear of being fired. `,
  },
  {
    title: `P. A.C. T.`,
    details: `Teams and individuals are motivated with Purpose, Autonomy, Clarity and Transparency.`,
  },
  {
    title: `The future belongs to autonomous teams`,
    details: `The best ideas come from unsupervised work in autonomous environments.`,
  },
  {
    title: `Work-life + Remote-office symphonies`,
    details: `The best work is done in remote-friendly environments with good work-life balance.`,
  },
  {
    title: `Budgets breed creativity`,
    details: `Time or cost budgets form constraints that lead to increased creativity.`,
  },
  {
    title: `Software should be fun to use while getting the job done`,
    details: `You rarely see “fun” and “getting things done” in the same sentence, but we strive to combine them in My Hours. `,
  },
];

export { aboutDetails };
